import { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import { TabulatorFull as Tabulator } from "tabulator-tables";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl } from "react-leaflet";
import type { Map as LeafletMap } from "leaflet";
import moment from "moment";
import "leaflet/dist/leaflet.css";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { useAuth } from "../modules/auth";
import { RequestMethod } from "../modules/services/core/_enums";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import { FiltroGlobal, useFiltrosAtivos } from "../../components/FiltrosGlobais";

interface ConsolidadoProps {
    local?: string;
    ativo?: string;
    idorganizacao?: string;
    dia?: string;
    dataDe?: string;
    dataAte?: string;
    timeout?: number;
    picktime?: number;
}

// ❌ REMOVIDO - Interfaces para filtros customizados (agora usa filtros globais)
// interface Organization {
//     OrganizationId: number;
//     OrganizationName: string;
//     Idcorporacao: number;
//     CorporationName: string;
// }

// interface Corporation {
//     id: number;
//     name: string;
// }

// Interface para os dados da API
interface ConsolidadoData {
    id: number;
    parentId: number;
    janela: string;
    idAtivo: number;
    ativo: string;
    local: string;
    localTipo: string;
    timestampMin: string;
    timestampMax: string;
    latitude: number;
    latitudeIni: number;
    latitudeEnd: number;
    longitude: number;
    longitudeIni: number;
    longitudeEnd: number;
    axisZ: number;
    contagem: number;
    orientacao: number;
    direcao: string;
    distanciaLatLong: number;
    ativoTipo: string;
    distancia: number;
}

interface SelectStylesProps {
    backgroundColor?: string;
    borderColor?: string;
    color?: string;
}

const selectStyles = {
    control: (base: any, state: { isFocused: boolean }) => ({
        ...base,
        backgroundColor: '#2D2D2D',
        borderColor: '#3D3D3D',
        color: '#FFFFFF'
    }),
    menu: (base: any) => ({
        ...base,
        backgroundColor: '#2D2D2D'
    }),
    option: (base: any, state: { isFocused: boolean }) => ({
        ...base,
        backgroundColor: state.isFocused ? '#3D3D3D' : '#2D2D2D',
        color: '#FFFFFF'
    }),
    singleValue: (base: any) => ({
        ...base,
        color: '#FFFFFF'
    }),
    multiValue: (base: any) => ({
        ...base,
        backgroundColor: '#3D3D3D'
    }),
    multiValueLabel: (base: any) => ({
        ...base,
        color: '#FFFFFF'
    }),
    input: (base: any) => ({
        ...base,
        color: '#FFFFFF'
    })
};

interface TabulatorRow {
    getData: () => any;
}

interface TabulatorCell {
    getData: () => any;
    getValue: () => any;
}

interface GroupByData {
    ativoTipo: string;
    ativo: string;
    localTipo: string;
    local: string;
    AtivoTipo: string;
    Ativo: string;
    LocalTipo: string;
    Local: string;
}

// Interface para os dados processados do Tabulator
interface TabulatorData {
    ativoTipo: string;
    ativo: string;
    localTipo: string;
    local: string;
    latitude: number;
    longitude: number;
    timestampMin: string;
    timestampMax: string;
    contagem: number;
    direcao: string;
    distancia: number;
}

interface TabulatorOptions {
    height?: number;
    layout?: string;
    data?: TabulatorData[];
    selectable?: number | boolean | "highlight";
    groupBy?: string[];
    groupHeader?: (value: any, count: number, data: any, group: any) => string;
    groupToggleElement?: string;
    groupStartOpen?: boolean;
    rowFormatter?: (row: any) => void;
    columns?: {
        title?: string;
        field?: string;
        formatter?: (cell: TabulatorCell) => string;
        width?: number;
        headerSort?: boolean;
        hozAlign?: string;
    }[];
}

// Adicione esta interface
interface ConsolidadoMqttData {
    id: number;
    DtHrPickTime: string;
    // ... outros campos necessários
}

// Estados globais do componente
const defaultDate = moment().format("YYYY-MM-DD");

const picktimeSelectStyles = {
    ...selectStyles,
    menu: (base: any) => ({
        ...base,
        backgroundColor: '#2D2D2D',
        position: 'absolute',
        zIndex: 9999,
        width: '100px',
        right: '0'
    }),
    menuList: (base: any) => ({
        ...base,
        maxHeight: '300px',
        overflowY: 'auto',
        backgroundColor: '#2D2D2D',
        '&::-webkit-scrollbar': {
            width: '4px'
        },
        '&::-webkit-scrollbar-track': {
            background: '#1e1e1e'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888'
        }
    }),
    control: (base: any) => ({
        ...base,
        backgroundColor: '#2D2D2D',
        borderColor: '#3D3D3D',
        minHeight: '38px',
        height: '38px'
    })
};

const Consolidado: React.FC<ConsolidadoProps> = ({
    local,
    ativo,
    idorganizacao,
    dia = defaultDate,
    dataDe,
    dataAte,
    timeout = 30000,
    picktime = 60
}) => {
    const { auth } = useAuth();
    const user = auth?.User;
    const emailUsuario = user?.Email;
    const httpClient = useHttpClient();
    const dataSetNamePBI = getDataSetNamePBI();

    // ✅ NOVO - Hook para acessar filtros globais
    const { selectedOrganizations: globalSelectedOrganizations, isInitialized } = useFiltrosAtivos();

    // Estados do componente
    const [selectedAtivo, setSelectedAtivo] = useState<string>('');
    // ❌ REMOVIDO - Estados de filtros customizados (agora usa filtros globais)
    // const [selectedOrganizations, setSelectedOrganizations] = useState<{ id: number, name: string }[]>([]);
    const [selectedDate, setSelectedDate] = useState<string>('');
    const [picktimeValue, setPicktimeValue] = useState<number>(picktime);

    const [sidebarVisible, setSidebarVisible] = useState(true);
    const [movimento, setMovimento] = useState<any[]>([]);
    const [status, setStatus] = useState<'stop' | 'start' | 'pause'>('stop');
    const [index, setIndex] = useState(0);
    const [infoboxContent, setInfoboxContent] = useState<string>('');

    // Estados de loading
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [hasData, setHasData] = useState(true);
    const [isLoadingAtivos, setIsLoadingAtivos] = useState(false);
    const [isLoadingDates, setIsLoadingDates] = useState(false);

    const tableRef = useRef<HTMLDivElement>(null);
    const mapaRef = useRef<L.Map | null>(null);
    const markersGroupRef = useRef<L.LayerGroup | null>(null);
    const markersRef = useRef<{ [key: string]: L.Marker }>({});
    const tabulatorInstanceRef = useRef<Tabulator | null>(null);

    // ❌ REMOVIDO - Estados para filtros customizados (agora usa filtros globais)
    // const [initialOrganizations, setInitialOrganizations] = useState<string[]>([]);
    // const [availableOrganizations, setAvailableOrganizations] = useState<Organization[]>([]);
    // const [availableCorporations, setAvailableCorporations] = useState<Corporation[]>([]);
    // const [selectedCorporation, setSelectedCorporation] = useState<number | null>(null);
    // const [userId, setUserId] = useState<string>("");
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    // Adicionar novo estado para ativos
    const [availableAtivos, setAvailableAtivos] = useState<string[]>([]);
    // ❌ REMOVIDO - Estado não utilizado
    // const [selectedAtivos, setSelectedAtivos] = useState<string[]>([]);

    // Adicionar novo estado para lista de ativos
    const [listaAtivo, setListaAtivo] = useState<any[]>([]);

    // Adicionar uma referência para o marcador atual
    const currentMarkerRef = useRef<L.Marker | null>(null);

    // Adicione este novo estado
    const [availableDates, setAvailableDates] = useState<string[]>([]);

    // Definição dos ícones
    const ColhedoraIcon = L.icon({
        iconUrl: 'https://portal.taggen.net/assets/imagens/colhedora-64px.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
    });

    const TratorIcon = L.icon({
        iconUrl: 'https://portal.taggen.net/assets/imagens/Trator-64px.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
    });

    const TransbordoIcon = L.icon({
        iconUrl: 'https://portal.taggen.net/assets/imagens/Transbordo-64px.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
    });

    const CarretaIcon = L.icon({
        iconUrl: 'https://portal.taggen.net/assets/imagens/Carreta-64px.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
    });

    // Função para limpar o marcador atual
    const clearCurrentMarker = () => {
        if (currentMarkerRef.current) {
            if (markersGroupRef.current) {
                markersGroupRef.current.removeLayer(currentMarkerRef.current);
            }
            currentMarkerRef.current = null;
        }
    };

    // Monitor de mudanças na lista de ativos
    useEffect(() => {
        const ativosCarreta = listaAtivo.filter(item =>
            item.Descricao &&
            item.Descricao.toLowerCase().startsWith('carreta')
        );

        console.log("Lista de ativos (apenas Carretas) atualizada:", {
            timestamp: new Date().toISOString(),
            totalAtivos: ativosCarreta.length,
            ativos: ativosCarreta.map(item => ({
                ativo: item.Ativo,
                descricao: item.Descricao,
                organizacao: item.Organizacao,
                status: item.StatusGateway
            }))
        });
    }, [listaAtivo]);

    // Funções auxiliares
    const formatDateTimeISO = (datetime: string) => {
        const data = new Date(datetime);
        return data.toISOString().replace('T', ' ').replace('.000Z', '');
    };

    const arredondar = (valor: number, casasDecimais: number) => {
        const fator = Math.pow(10, casasDecimais);
        return Math.ceil(valor * fator) / fator;
    };

    // Função para obter dados do consolidado
    const obterConsolidado = async () => {
        // Verificar se todos os campos obrigatórios estão preenchidos
        if (!selectedAtivo || globalSelectedOrganizations.length === 0 || !selectedDate) {
            console.log('Campos obrigatórios não preenchidos');
            return [];
        }

        setIsLoading(true);
        setLoadingMessage('Carregando dados do consolidado...');
        setHasData(true);

        // Use os valores dos estados - adaptado para filtros globais
        const dados = {
            ativo: selectedAtivo,
            // Para filtros globais, usamos o nome da organização diretamente
            idorganization: globalSelectedOrganizations.length > 0 ? globalSelectedOrganizations[0] : undefined,
            dtpicktime: selectedDate,
            format: 'JSON',
            PickTime: picktimeValue
        };

        console.log('Iniciando busca com parâmetros:', {
            timestamp: new Date().toISOString(),
            dados
        });

        try {
            const response = await fetch(`${backendUrl}/api/ConsolidadoNred`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                },
                body: JSON.stringify(dados)
            });

            if (!response.ok) {
                console.error('Erro na resposta da API:', {
                    status: response.status,
                    statusText: response.statusText
                });
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            console.log('Resposta da API:', {
                timestamp: new Date().toISOString(),
                totalRegistros: data.length,
                primeiroRegistro: data[0],
                ultimoRegistro: data[data.length - 1]
            });

            // Verificar se há dados
            if (!data || data.length === 0) {
                setHasData(false);
                console.log('Nenhum dado encontrado para os filtros selecionados');
            } else {
                setHasData(true);
            }

            return data;
        } catch (error) {
            console.error('Erro ao obter consolidado:', {
                timestamp: new Date().toISOString(),
                erro: error instanceof Error ? error.message : 'Erro desconhecido',
                stack: error instanceof Error ? error.stack : undefined
            });
            setHasData(false);
            return [];
        } finally {
            setIsLoading(false);
            setLoadingMessage('');
        }
    };

    // Download de arquivos
    const dwConsolidado = async (formato: 'XLS' | 'HTML' | 'JSON') => {
        const dados = {
            ativo,
            idorganization: idorganizacao,
            dtpicktime: dia,
            format: formato,
            PickTime: picktimeValue
        };

        try {
            const response = await fetch(`${backendUrl}/api/ConsolidadoNred`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                },
                body: JSON.stringify(dados)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let blob;
            let filename;

            switch (formato) {
                case 'XLS':
                    const base64Data = await response.text();
                    const byteCharacters = atob(base64Data.replace(/^"|"$/g, ''));
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    filename = 'consolidado.xlsx';
                    break;
                case 'HTML':
                    blob = await response.blob();
                    filename = 'consolidado.html';
                    break;
                case 'JSON':
                    blob = new Blob([await response.text()], { type: 'application/json' });
                    filename = 'consolidado.json';
                    break;
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Erro ao baixar arquivo:', error);
        }
    };

    // ❌ REMOVIDO - Funções de filtros customizados (agora usa filtros globais)
    // Função para buscar ID do usuário
    // const fetchUserId = async () => {
    //     if (!emailUsuario) {
    //         console.log("Email do usuário não disponível");
    //         return;
    //     }
    //     // ... resto da função removida
    // };

    // Função para buscar organizações do usuário  
    // const fetchUserOrganizations = async (id: string) => {
    //     // ... função removida
    // };

    // Função para obter lista de ativos
    const obterListaAtivo = async (orgs?: string[]) => {
        setIsLoadingAtivos(true);

        try {
            const endpoint = orgs ? '/Gerenciamento/PowerBI/ObterAtivosByOrg' : '/Gerenciamento/PowerBI/ObterAtivos';

            // Cria um objeto URLSearchParams para construir a query string
            const queryParams = new URLSearchParams();
            if (dataSetNamePBI) {
                queryParams.append('datasetName', dataSetNamePBI);
            }

            if (orgs) {
                orgs.forEach(org => {
                    queryParams.append('organization', org);
                });
            }

            // Concatena a query string ao endpoint
            const queryString = queryParams.toString();
            const fullUrl = `${endpoint}?${queryString}`;

            console.log("Tentando obter lista de ativos:", {
                url: fullUrl,
                organizacoes: orgs,
                datasetName: dataSetNamePBI
            });

            const response = await httpClient.request({
                method: RequestMethod.GET,
                endpoint: fullUrl,
            });

            if (response.success && response.payload) {
                setListaAtivo(response.payload);
                console.log("Dados recebidos da API:", {
                    totalRegistros: response.payload.length,
                    primeiroRegistro: response.payload[0],
                    estruturaDados: response.payload[0] ? Object.keys(response.payload[0]) : []
                });

                // Extrair ativos únicos dos dados
                const uniqueAtivos = Array.from(
                    new Set(response.payload.map((item: any) => item.Ativo))
                ).filter((ativo): ativo is string =>
                    typeof ativo === 'string' && ativo !== ''
                );

                setAvailableAtivos(uniqueAtivos);
            } else {
                throw new Error('Resposta da API não contém dados válidos');
            }
        } catch (error) {
            console.error("Erro detalhado ao obter lista de ativos:", {
                mensagem: error instanceof Error ? error.message : 'Erro desconhecido',
                stack: error instanceof Error ? error.stack : undefined,
                timestamp: new Date().toISOString()
            });

            // Resetar estados em caso de erro
            setListaAtivo([]);
            setAvailableAtivos([]);
        } finally {
            setIsLoadingAtivos(false);
        }
    };

    // ❌ REMOVIDO - Efeito de inicialização customizada (agora usa filtros globais)
    // useEffect(() => {
    //     const initializeUserData = async () => {
    //         console.log("Iniciando inicialização dos dados");
    //         // Removido código de inicialização customizada
    //     };
    //     initializeUserData();
    // }, [emailUsuario]);

    // ✅ NOVO - Efeito para carregar ativos quando filtros globais inicializam
    useEffect(() => {
        if (isInitialized) {
            obterListaAtivo(); // Carregar lista inicial de ativos
        }
    }, [isInitialized]);

    // Adicionar efeito para atualizar lista de ativos quando organizações são selecionadas
    useEffect(() => {
        if (globalSelectedOrganizations.length > 0) {
            obterListaAtivo(globalSelectedOrganizations);
        } else {
            obterListaAtivo();
        }
    }, [globalSelectedOrganizations]);

    // ✅ NOVO - Callback quando filtros globais mudam
    const handleFiltroChange = () => {
        console.log('🔄 Filtros globais mudaram, limpando dados...');
        // Limpar dados quando filtros mudam
        setMovimento([]);
        if (tabulatorInstanceRef.current) {
            tabulatorInstanceRef.current.setData([]);
        }
    };

    // Filtrar apenas ativos que são carretas para o seletor
    const filteredAtivosForSelect = availableAtivos.filter(ativoId => {
        const ativoInfo = listaAtivo.find(item => item.Ativo === ativoId);
        return ativoInfo?.Descricao?.toLowerCase().startsWith('carreta');
    });

    // Adicione esta nova função para buscar as datas disponíveis
    const fetchAvailableDates = async (selectedAtivo: string) => {
        setIsLoadingDates(true);

        try {
            const response = await fetch(`${backendUrl}/api/ConsolidadoMqtt/ativo/${selectedAtivo}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json() as ConsolidadoMqttData[];

            const uniqueDates = Array.from(new Set(
                data.map((item: ConsolidadoMqttData) => {
                    const date = moment(item.DtHrPickTime, "DD/MM/YYYY HH:mm:ss");
                    return date.format("YYYY-MM-DD");
                })
            ));

            uniqueDates.sort();
            setAvailableDates(uniqueDates);
        } catch (error) {
            console.error("Erro ao buscar datas disponíveis:", error);
            setAvailableDates([]);
        } finally {
            setIsLoadingDates(false);
        }
    };

    // Modifique o useEffect que monitora a seleção de ativos
    useEffect(() => {
        if (selectedAtivo) {
            // Limpar data selecionada quando ativo muda
            setSelectedDate('');
            fetchAvailableDates(selectedAtivo);
        } else {
            setAvailableDates([]);
            setSelectedDate('');
        }
    }, [selectedAtivo]);

    // Inicialização e carregamento de dados
    useEffect(() => {
        const initializeData = async () => {
            try {
                const data = await obterConsolidado();
                if (data && Array.isArray(data) && data.length > 0) {
                    console.log("Dados recebidos para Tabulator:", data);

                    const processedData: TabulatorData[] = data.map((row: ConsolidadoData) => ({
                        ativoTipo: row.ativoTipo,
                        ativo: row.ativo,
                        localTipo: row.localTipo,
                        local: row.local,
                        latitude: row.latitude,
                        longitude: row.longitude,
                        timestampMin: row.timestampMin,
                        timestampMax: row.timestampMax,
                        contagem: row.contagem,
                        direcao: row.direcao,
                        distancia: row.distancia
                    }));

                    console.log("Dados processados:", processedData);
                    setMovimento(processedData);

                    if (tableRef.current) {
                        initializeTabulator(processedData);
                    }
                } else {
                    console.log("Nenhum dado encontrado ou dados inválidos:", data);
                    setMovimento([]);
                    if (tableRef.current && tabulatorInstanceRef.current) {
                        tabulatorInstanceRef.current.setData([]);
                    }
                }
            } catch (error) {
                console.error("Erro ao inicializar dados:", error);
                setMovimento([]);
            }
        };

        // Só executar se todos os campos necessários estiverem preenchidos
        if (selectedAtivo && globalSelectedOrganizations.length > 0 && selectedDate) {
            initializeData();
        }
    }, [selectedAtivo, globalSelectedOrganizations, selectedDate, picktimeValue]);

    // Inicialização do Tabulator
    const initializeTabulator = (data: TabulatorData[]) => {
        if (!tableRef.current) {
            console.error("Referência da tabela não encontrada");
            return;
        }

        try {
            if (tabulatorInstanceRef.current) {
                tabulatorInstanceRef.current.destroy();
            }

            const options: TabulatorOptions = {
                height: 650,
                layout: "fitDataFill",
                data: data,
                selectable: "highlight",
                groupBy: ["localTipo", "local"],
                groupHeader: function (value, count, data, group) {
                    let header = value;
                    if (group.getField() === "localTipo") {
                        header = `${value} (${count} items)`;
                    } else if (group.getField() === "local") {
                        header = `${value}`;
                    }
                    return header;
                },
                groupToggleElement: "header",
                groupStartOpen: true,
                rowFormatter: function (row) {
                    // Remove o rowFormatter pois agora usamos classes CSS
                },
                columns: [
                    {
                        title: "Data/Hora Inicio do evento",
                        field: "timestampMin",
                        formatter: (cell: TabulatorCell) => formatDateTimeISO(cell.getValue())
                    },
                    {
                        title: "Data/Hora Fim do evento",
                        field: "timestampMax",
                        formatter: (cell: TabulatorCell) => formatDateTimeISO(cell.getValue())
                    },
                    {
                        title: "Lat/Long",
                        formatter: (cell: TabulatorCell) => {
                            const data = cell.getData() as ConsolidadoData;
                            const lat = arredondar(data.latitude, 4);
                            const lng = arredondar(data.longitude, 4);
                            return lat && lng ? `${lat}, ${lng}` : '-';
                        }
                    },
                    {
                        title: "Leituras no latlong",
                        field: "contagem",
                        headerSort: true,
                        hozAlign: "center"
                    }
                ]
            };

            console.log("Inicializando Tabulator com opções:", options);
            tabulatorInstanceRef.current = new Tabulator(tableRef.current, options as any);

            // Modificar o evento de clique na linha
            tabulatorInstanceRef.current.on("rowClick", function (e: any, row: any) {
                // Desselecionar todas as outras linhas
                tabulatorInstanceRef.current?.deselectRow();
                // Selecionar apenas a linha clicada
                row.select();

                const data = row.getData();
                if (data.latitude && data.longitude) {
                    // Remover todos os marcadores existentes do mapa
                    if (mapaRef.current) {
                        if (markersGroupRef.current) {
                            markersGroupRef.current.remove();
                        }
                        // Criar um novo LayerGroup
                        markersGroupRef.current = L.layerGroup().addTo(mapaRef.current);
                    }

                    // Selecionar o ícone apropriado baseado no tipo de ativo
                    let selectedIcon;
                    switch (data.ativoTipo) {
                        case 'Colhedora':
                            selectedIcon = ColhedoraIcon;
                            break;
                        case 'Trator':
                            selectedIcon = TratorIcon;
                            break;
                        case 'Carreta':
                            selectedIcon = CarretaIcon;
                            break;
                        case 'Transbordo':
                            selectedIcon = TransbordoIcon;
                            break;
                        default:
                            selectedIcon = CarretaIcon; // Ícone padrão caso não encontre o tipo
                    }

                    // Criar novo marcador com o ícone selecionado
                    const marker = L.marker([data.latitude, data.longitude], {
                        title: data.ativo,
                        icon: selectedIcon
                    });

                    // Adicionar popup com informações
                    const popupContent = `
                        <div style="
                            padding: 10px;
                            min-width: 200px;
                            font-family: Arial, sans-serif;
                        ">
                            <h4 style="
                                margin: 0 0 8px 0;
                                color: #333;
                                font-size: 14px;
                                border-bottom: 1px solid #eee;
                                padding-bottom: 5px;
                            ">${data.ativo}</h4>
                            <p style="margin: 4px 0;"><strong>Local:</strong> ${data.local}</p>
                            <p style="margin: 4px 0;"><strong>Leituras:</strong> ${data.contagem}</p>
                            <p style="margin: 4px 0;"><strong>Direção:</strong> ${data.direcao}</p>
                            <p style="margin: 4px 0;"><strong>Distância:</strong> ${data.distancia}m</p>
                            <p style="margin: 4px 0;"><strong>Coordenadas:</strong><br/>${arredondar(data.latitude, 4)}, ${arredondar(data.longitude, 4)}</p>
                        </div>
                    `;
                    marker.bindPopup(popupContent, {
                        maxWidth: 300,
                        className: 'custom-popup'
                    });

                    // Adicionar o novo marcador ao grupo e abrir o popup
                    if (markersGroupRef.current) {
                        markersGroupRef.current.addLayer(marker);
                        marker.openPopup();
                    }

                    // Centralizar mapa com animação suave
                    if (mapaRef.current) {
                        mapaRef.current.setView([data.latitude, data.longitude], 16, {
                            animate: true,
                            duration: 0.5
                        });
                    }

                    // Atualizar infobox com mais informações formatadas
                    setInfoboxContent(`
                        Ativo: ${data.ativo}
                        Local: ${data.local}
                        Coordenadas: ${arredondar(data.latitude, 4)}, ${arredondar(data.longitude, 4)}
                        Data/Hora Início: ${formatDateTimeISO(data.timestampMin)}
                        Data/Hora Fim: ${formatDateTimeISO(data.timestampMax)}
                        Direção: ${data.direcao}
                        Distância: ${data.distancia}m
                        Leituras: ${data.contagem}
                    `);
                }
            });

        } catch (error) {
            console.error("Erro ao inicializar Tabulator:", error);
        }
    };

    // Este useEffect foi removido para evitar duplicação com o initializeData

    console.log('Render - globalSelectedOrganizations:', globalSelectedOrganizations, 'isInitialized:', isInitialized);

    // ✅ Estado de loading enquanto filtros inicializam
    if (!isInitialized) {
        return (
            <div className="consolidado-container" style={{ minHeight: '100vh', padding: '20px' }}>
                <div style={{ padding: "20px", textAlign: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                        <i className="ui loading spinner icon"></i>
                        <span>Carregando filtros...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="consolidado-container" style={{ minHeight: '100vh', padding: '20px' }}>
            {/* Modal de Loading */}
            {isLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10000,
                    backdropFilter: 'blur(2px)'
                }}>
                    <div style={{
                        backgroundColor: 'var(--bs-body-bg)',
                        borderRadius: '12px',
                        padding: '40px',
                        textAlign: 'center',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                        border: '1px solid var(--bs-border-color)',
                        minWidth: '300px'
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '20px'
                        }}>
                            {/* Spinner animado */}
                            <div style={{
                                width: '50px',
                                height: '50px',
                                border: '4px solid var(--bs-border-color)',
                                borderTop: '4px solid var(--bs-primary)',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }}></div>

                            <div>
                                <h4 style={{
                                    color: 'var(--bs-body-color)',
                                    margin: '0 0 10px 0',
                                    fontSize: '18px'
                                }}>
                                    Carregando...
                                </h4>
                                <p style={{
                                    color: 'var(--bs-secondary-color)',
                                    margin: 0,
                                    fontSize: '14px'
                                }}>
                                    {loadingMessage || 'Processando dados...'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style>
                {`
                    /* Animação do spinner */
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }

                    /* Estilos para o Tabulator */
                    .tabulator {
                        background-color: var(--bs-body-bg) !important;
                        border: 1px solid var(--bs-border-color) !important;
                        border-radius: 8px !important;
                        overflow: hidden !important;
                    }
                    .tabulator-group {
                        background-color: var(--bs-secondary-bg) !important;
                        color: var(--bs-body-color) !important;
                        font-size: 14px !important;
                    }
                    .tabulator-group-level-0 {
                        background-color: var(--bs-dark-bg-subtle) !important;
                        font-weight: bold !important;
                        font-size: 16px !important;
                        text-transform: uppercase !important;
                    }
                    .tabulator-group-level-1 {
                        padding-left: 30px !important;
                        background-color: var(--bs-secondary-bg) !important;
                        border-left: 4px solid var(--bs-success) !important;
                    }
                    .tabulator-group-toggle {
                        color: var(--bs-body-color) !important;
                    }
                    .tabulator-group-header {
                        padding: 10px !important;
                    }
                    .tabulator-row {
                        border-bottom: 1px solid var(--bs-border-color) !important;
                        transition: all 0.2s ease-in-out !important;
                        background-color: var(--bs-body-bg) !important;
                        color: var(--bs-body-color) !important;
                    }
                    .tabulator-row:hover {
                        background-color: var(--bs-secondary-bg) !important;
                        cursor: pointer !important;
                    }
                    .tabulator-row.tabulator-selected {
                        background-color: var(--bs-tertiary-bg) !important;
                        color: var(--bs-body-color) !important;
                    }
                    .tabulator-row.tabulator-selected:hover {
                        background-color: var(--bs-secondary-bg) !important;
                    }
                    .tabulator-row.tabulator-group {
                        border-bottom: 2px solid var(--bs-border-color) !important;
                    }
                    .tabulator-cell {
                        padding: 8px !important;
                        color: var(--bs-body-color) !important;
                    }
                    .tabulator-header {
                        background-color: var(--bs-dark-bg-subtle) !important;
                        color: var(--bs-body-color) !important;
                        border-bottom: 2px solid var(--bs-border-color) !important;
                    }
                    .tabulator-col {
                        background-color: var(--bs-dark-bg-subtle) !important;
                        color: var(--bs-body-color) !important;
                        border-right: 1px solid var(--bs-border-color) !important;
                    }

                    /* Estilos para o React-Select */
                    .react-select__control {
                        background-color: var(--bs-body-bg) !important;
                        border-color: var(--bs-border-color) !important;
                        color: var(--bs-body-color) !important;
                        min-height: 38px !important;
                        box-shadow: none !important;
                    }
                    .react-select__control:hover {
                        border-color: var(--bs-primary) !important;
                    }
                    .react-select__control--is-focused {
                        border-color: var(--bs-primary) !important;
                        box-shadow: 0 0 0 1px var(--bs-primary) !important;
                    }
                    .react-select__menu {
                        background-color: var(--bs-body-bg) !important;
                        border: 1px solid var(--bs-border-color) !important;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
                        z-index: 9999 !important;
                    }
                    .react-select__option {
                        background-color: var(--bs-body-bg) !important;
                        color: var(--bs-body-color) !important;
                        cursor: pointer !important;
                        padding: 8px 12px !important;
                    }
                    .react-select__option:hover {
                        background-color: var(--bs-secondary-bg) !important;
                    }
                    .react-select__option--is-selected {
                        background-color: var(--bs-primary) !important;
                        color: var(--bs-body-bg) !important;
                    }
                    .react-select__single-value {
                        color: var(--bs-body-color) !important;
                    }
                    .react-select__input {
                        color: var(--bs-body-color) !important;
                    }
                    .react-select__indicator {
                        color: var(--bs-body-color) !important;
                    }
                    .react-select__indicator:hover {
                        color: var(--bs-primary) !important;
                    }
                    .react-select__placeholder {
                        color: var(--bs-secondary-color) !important;
                    }
                    .react-select__multi-value {
                        background-color: #e3f2fd !important;
                    }
                    .react-select__multi-value__label {
                        color: #1976d2 !important;
                    }
                    .react-select__multi-value__remove {
                        color: #1976d2 !important;
                    }
                    .react-select__multi-value__remove:hover {
                        background-color: var(--bs-danger) !important;
                        color: var(--bs-body-bg) !important;
                    }
                    .react-select__value-container {
                        padding: 2px 8px !important;
                    }
                    .react-select__dropdown-indicator {
                        padding: 4px !important;
                    }

                    /* Estilos para os filtros do header */
                    .tabulator-header-filter input {
                        background-color: var(--bs-body-bg) !important;
                        border: 1px solid var(--bs-border-color) !important;
                        color: var(--bs-body-color) !important;
                        padding: 4px 8px !important;
                        border-radius: 4px !important;
                    }
                    .tabulator-header-filter input:focus {
                        outline: none !important;
                        border-color: var(--bs-primary) !important;
                        box-shadow: 0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.25) !important;
                    }
                    .tabulator-header-filter select {
                        background-color: var(--bs-body-bg) !important;
                        border: 1px solid var(--bs-border-color) !important;
                        color: var(--bs-body-color) !important;
                        padding: 4px 8px !important;
                        border-radius: 4px !important;
                    }
                    .tabulator-header-filter select:focus {
                        outline: none !important;
                        border-color: var(--bs-primary) !important;
                        box-shadow: 0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.25) !important;
                    }

                    /* Estilos para a barra de rolagem */
                    ::-webkit-scrollbar {
                        width: 8px;
                        height: 8px;
                    }
                    ::-webkit-scrollbar-track {
                        background: var(--bs-tertiary-bg);
                        border-radius: 4px;
                    }
                    ::-webkit-scrollbar-thumb {
                        background: var(--bs-secondary-color);
                        border-radius: 4px;
                    }
                    ::-webkit-scrollbar-thumb:hover {
                        background: var(--bs-primary);
                    }

                    /* Estilos para botões */
                    button {
                        transition: all 0.2s ease-in-out !important;
                    }
                    button:hover {
                        opacity: 0.8 !important;
                    }
                    button:active {
                        transform: scale(0.98) !important;
                    }
                `}
            </style>
            {/* Cabeçalho */}
            <div style={{
                marginBottom: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                backgroundColor: 'var(--bs-body-bg)',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}>
                {/* Título */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <h2 style={{
                        color: 'var(--bs-warning)',
                        margin: 0,
                        fontSize: '24px',
                        fontWeight: 'bold'
                    }}>
                        Consolidado
                    </h2>
                    <span style={{
                        color: 'var(--bs-body-color)',
                        fontSize: '18px'
                    }}>
                        Carreta
                    </span>
                </div>

                {/* Filtros */}
                <div style={{
                    display: 'flex',
                    gap: '15px',
                    flexWrap: 'wrap'
                }}>
                    <FiltroGlobal
                        onCorporationChange={handleFiltroChange}
                        onOrganizationChange={handleFiltroChange}
                        style={{
                            corporation: { width: "300px" },
                            organization: { width: "300px" }
                        }}
                    />

                    <div style={{ width: '250px' }}>
                        <Select
                            classNamePrefix="react-select"
                            styles={{
                                menu: (base: Record<string, any>) => ({
                                    ...base,
                                    zIndex: 9999,
                                    position: 'absolute'
                                }),
                                menuList: (base: Record<string, any>) => ({
                                    ...base,
                                    maxHeight: '300px'
                                })
                            }}
                            options={filteredAtivosForSelect.map(ativo => ({
                                label: ativo,
                                value: ativo,
                            }))}
                            onChange={(selectedOption: any) => {
                                const ativoValue = selectedOption ? selectedOption.value : '';
                                setSelectedAtivo(ativoValue);
                            }}
                            value={selectedAtivo ? { label: selectedAtivo, value: selectedAtivo } : null}
                            placeholder={isLoadingAtivos ? "Carregando ativos..." : "Filtrar por Ativo (Carretas)"}
                            isClearable
                            isLoading={isLoadingAtivos}
                            isDisabled={isLoadingAtivos}
                        />
                    </div>

                    {/* Seletor de data */}
                    <div style={{ width: '250px' }}>
                        <Select
                            classNamePrefix="react-select"
                            styles={{
                                menu: (base: Record<string, any>) => ({
                                    ...base,
                                    zIndex: 9999,
                                    position: 'absolute'
                                }),
                                menuList: (base: Record<string, any>) => ({
                                    ...base,
                                    maxHeight: '300px'
                                })
                            }}
                            options={availableDates.map(date => ({
                                label: moment(date).format("DD/MM/YYYY"),
                                value: date,
                            }))}
                            onChange={(selectedOption: any) => {
                                const dateValue = selectedOption ? selectedOption.value : '';
                                setSelectedDate(dateValue);
                            }}
                            value={selectedDate ? {
                                label: moment(selectedDate).format("DD/MM/YYYY"),
                                value: selectedDate
                            } : null}
                            placeholder={
                                !selectedAtivo ? "Selecione um ativo primeiro" :
                                    isLoadingDates ? "Carregando datas..." :
                                        availableDates.length === 0 ? "Nenhuma data disponível" :
                                            "Selecionar Data"
                            }
                            isClearable
                            isLoading={isLoadingDates}
                            isDisabled={!selectedAtivo || isLoadingDates}
                        />
                    </div>

                    {/* Seletor de Picktime */}
                    <div style={{ width: '100px', position: 'relative' }}>
                        <Select
                            classNamePrefix="react-select"
                            styles={{
                                ...selectStyles,
                                menu: (base: Record<string, any>) => ({
                                    ...base,
                                    zIndex: 3000,
                                    position: 'absolute',
                                    width: '100%',
                                    marginTop: '4px'
                                }),
                                menuList: (base: Record<string, any>) => ({
                                    ...base,
                                    maxHeight: '300px'
                                }),
                                control: (base: Record<string, any>) => ({
                                    ...base,
                                    backgroundColor: 'var(--bs-body-bg)',
                                    borderColor: 'var(--bs-border-color)',
                                    minHeight: '38px',
                                    height: '38px'
                                })
                            }}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            options={[
                                { value: 10, label: '10' },
                                { value: 20, label: '20' },
                                { value: 30, label: '30' },
                                { value: 60, label: '60' },
                                { value: 90, label: '90' },
                                { value: 120, label: '120' },
                                { value: 180, label: '180' },
                                { value: 240, label: '240' },
                                { value: 300, label: '300' }
                            ]}
                            onChange={(selectedOption: any) => {
                                const picktimeValue = selectedOption ? selectedOption.value : 60;
                                setPicktimeValue(picktimeValue);
                            }}
                            defaultValue={{ value: 60, label: '60' }}
                            placeholder="Picktime"
                        />
                    </div>
                </div>

                {/* Barra de ações */}
                <div style={{
                    display: 'flex',
                    gap: '15px',
                    alignItems: 'center'
                }}>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            backgroundColor: 'var(--bs-dark-bg-subtle)',
                            border: 'none',
                            padding: '8px 15px',
                            color: 'var(--bs-body-color)',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        <i className="refresh icon" />
                        Atualizar
                    </button>

                    <div style={{ color: 'var(--bs-body-color)' }}>
                        Download:
                        <button
                            onClick={() => dwConsolidado('XLS')}
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                color: 'var(--bs-success)',
                                cursor: 'pointer',
                                marginLeft: '10px',
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Excel
                        </button>
                        <button
                            onClick={() => dwConsolidado('HTML')}
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                color: 'var(--bs-info)',
                                cursor: 'pointer',
                                marginLeft: '10px',
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Html
                        </button>
                        <button
                            onClick={() => dwConsolidado('JSON')}
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                color: 'var(--bs-warning)',
                                cursor: 'pointer',
                                marginLeft: '10px',
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Json
                        </button>
                    </div>
                </div>
            </div>

            {/* Conteúdo principal */}
            <div style={{
                display: 'flex',
                gap: '20px',
                height: 'calc(100vh - 200px)'
            }}>
                {/* Tabela */}
                <div style={{
                    flex: '1',
                    backgroundColor: '#2D2D2D',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    position: 'relative'
                }}>
                    {/* Mensagem de filtros não preenchidos */}
                    {(!selectedAtivo || globalSelectedOrganizations.length === 0 || !selectedDate) && !isLoading && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'var(--bs-body-bg)',
                            zIndex: 100
                        }}>
                            <div style={{
                                textAlign: 'center',
                                padding: '40px',
                                color: 'var(--bs-secondary-color)'
                            }}>
                                <div style={{
                                    fontSize: '48px',
                                    marginBottom: '20px',
                                    opacity: 0.5
                                }}>
                                    🔍
                                </div>
                                <h3 style={{
                                    color: 'var(--bs-body-color)',
                                    marginBottom: '10px',
                                    fontSize: '20px'
                                }}>
                                    Selecione os filtros
                                </h3>
                                <p style={{
                                    fontSize: '14px',
                                    margin: 0,
                                    maxWidth: '300px'
                                }}>
                                    Para visualizar os dados, selecione a organização, o ativo e a data desejados.
                                </p>
                                <div style={{
                                    marginTop: '20px',
                                    padding: '10px',
                                    backgroundColor: 'var(--bs-secondary-bg)',
                                    borderRadius: '6px',
                                    fontSize: '12px'
                                }}>
                                    <strong>Campos obrigatórios:</strong><br />
                                    {!globalSelectedOrganizations.length && (
                                        <>• Organização<br /></>
                                    )}
                                    {!selectedAtivo && (
                                        <>• Ativo (Carreta)<br /></>
                                    )}
                                    {!selectedDate && (
                                        <>• Data</>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Mensagem de sem dados */}
                    {!hasData && !isLoading && selectedAtivo && globalSelectedOrganizations.length > 0 && selectedDate && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'var(--bs-body-bg)',
                            zIndex: 100
                        }}>
                            <div style={{
                                textAlign: 'center',
                                padding: '40px',
                                color: 'var(--bs-secondary-color)'
                            }}>
                                <div style={{
                                    fontSize: '48px',
                                    marginBottom: '20px',
                                    opacity: 0.5
                                }}>
                                    📊
                                </div>
                                <h3 style={{
                                    color: 'var(--bs-body-color)',
                                    marginBottom: '10px',
                                    fontSize: '20px'
                                }}>
                                    Sem dados para exibir
                                </h3>
                                <p style={{
                                    fontSize: '14px',
                                    margin: 0,
                                    maxWidth: '300px'
                                }}>
                                    Não foram encontrados dados para os filtros selecionados.
                                    Tente ajustar os parâmetros de busca.
                                </p>
                                <div style={{
                                    marginTop: '20px',
                                    padding: '10px',
                                    backgroundColor: 'var(--bs-secondary-bg)',
                                    borderRadius: '6px',
                                    fontSize: '12px'
                                }}>
                                    <strong>Filtros atuais:</strong><br />
                                    Ativo: {selectedAtivo}<br />
                                    Data: {selectedDate ? moment(selectedDate).format("DD/MM/YYYY") : 'Não selecionada'}<br />
                                    Picktime: {picktimeValue}s
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Container da tabela */}
                    <div ref={tableRef} style={{
                        height: '100%',
                        width: '100%'
                    }}></div>
                </div>

                {/* Mapa */}
                {sidebarVisible && (
                    <div style={{
                        width: '800px',
                        backgroundColor: '#2D2D2D',
                        borderRadius: '4px',
                        overflow: 'hidden',
                        height: '100%'
                    }}>
                        <MapContainer
                            center={[-21.4169, -48.2946]}
                            zoom={13}
                            style={{ height: '100%', width: '100%' }}
                            ref={(map) => {
                                if (map) {
                                    mapaRef.current = map;
                                    markersGroupRef.current = L.layerGroup().addTo(map);
                                }
                            }}
                        >
                            <LayersControl position="topright">
                                <LayersControl.BaseLayer checked name="OpenStreetMap">
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        attribution='&copy; OpenStreetMap contributors'
                                    />
                                </LayersControl.BaseLayer>
                                <LayersControl.BaseLayer name="Satélite">
                                    <TileLayer
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                        attribution="Tiles © Esri"
                                    />
                                </LayersControl.BaseLayer>
                            </LayersControl>
                        </MapContainer>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Consolidado;
